import React from 'react';
import { useLazyQuery, useMutation, gql } from '@apollo/client';
import StockUnserialized from './StockUnserialized';

const ZONE_INVENTORY_BALANCES = gql`
  query unserializedZoneInventoryBalancesForStock($zoneId: ID!, $companyId: ID!) {
    unserializedPaginatedZoneInventoryBalancesByZone(
      zoneId: $zoneId
      companyId: $companyId
      includeQuarantined: true
      paginationAttributes: { limit: 200, skip: 0 }
    ) {
      zoneInventoryBalances {
        id
        stocked
        quarantined
        lot
        expiration
        zone {
          id
          name
        }
        product {
          id
          title
          fdaProduct {
            id
            name
            elevenDigitNdc
            deaSchedule
          }
          upcProduct {
            id
            upc
          }
        }
      }
      pagination {
        totalRecords
      }
    }
  }
`;

const STOCK_UNSERIALIZED_ITEMS = gql`
  mutation stockUnserializedItems(
    $companyId: ID!
    $stockZoneId: ID!
    $stockUnserializedItemsAttributes: [StockUnserializedItemsAttributes!]!
  ) {
    stockUnserializedItems(
      companyId: $companyId
      stockZoneId: $stockZoneId
      stockUnserializedItemsAttributes: $stockUnserializedItemsAttributes
    )
  }
`;

const StockUnserializedData = (props) => {
  const [stockUnserializedItems] = useMutation(STOCK_UNSERIALIZED_ITEMS);
  const [getZoneInventoryBalances, { data: zoneInventoryBalancesData }] = useLazyQuery(
    ZONE_INVENTORY_BALANCES,
    { fetchPolicy: 'network-only' }
  );

  const {
    unserializedPaginatedZoneInventoryBalancesByZone: { zoneInventoryBalances = [] } = {}
  } = zoneInventoryBalancesData || {};

  // Only quarantined product can be re-stocked from this flow.
  const quarantinedZoneInventoryBalances = zoneInventoryBalances.filter(
    ({ quarantined }) => quarantined > 0
  );

  return (
    <StockUnserialized
      stockUnserializedItems={stockUnserializedItems}
      getZoneInventoryBalances={getZoneInventoryBalances}
      zoneInventoryBalances={quarantinedZoneInventoryBalances}
      {...props}
    />
  );
};

export default StockUnserializedData;
